import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CreateTaskError } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: CreateTaskError;
  createKanbanTask(request: Boundaries["createKanbanTask"]["request"]): void;
}

function useCreateKanbanTask(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isCreateKanbanTaskRequestPending),
    isRequestSuccess: useSelector(selector.isCreateKanbanTaskRequestSuccess),
    isRequestFailure: useSelector(selector.isCreateKanbanTaskRequestFailure),
    error: useSelector(selector.getCreateKanbanTaskError),
    createKanbanTask: core.createKanbanTask,
  };
}

export { useCreateKanbanTask };
